<template>
  <div>
    <the-game-gallery />
    <the-entry :data="entry" gray />
  </div>
</template>

<script>
import TheGameGallery from '@/components/TheGameGallery'
import TheEntry from '@/components/TheEntry'

export default {
  components: { TheGameGallery, TheEntry },
  data() {
    return { entry: ['join', 'about', 'honor', 'business'] }
  },
  middleware: 'games',
}
</script>
